import styled, { css } from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { media, buttonCSS, type Button } from '@simplywallst/ui-core';

const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

export const StyledTable = styled('table')`
  border-collapse: separate;
  border-spacing: 0;
  display: block;
  thead {
    position: sticky;
    top: var(--thead-top);
  }
`;

export const TableHeadRow = styled('tr')`
  white-space: nowrap;
`;

export const TableHeadCell = styled('th')`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.textSoft};
  background-color: ${({ theme }) => theme.color.noir};
  text-align: left;
  padding: ${({ theme }) => `${theme.x1}px`};

  &:first-child {
    padding-left: ${({ theme }) => theme.x1}px;
    ${media.mdUp`
      padding-left: ${({ theme }) => theme.x2}px;
    `}
    width: 100%;
  }
  &:last-child {
    padding-right: ${({ theme }) => theme.x1}px;
    ${media.mdUp`
      padding-right: ${({ theme }) => theme.x2}px;
    `}
    text-align: right;
  }
`;

export const TableRow = styled('tr')`
  white-space: nowrap;
  height: auto;
`;

const RowCellStyle = css`
  transition: background-color 0.4s ${cubicBezier};
  padding: ${({ theme }) => `${theme.x0_5}px ${theme.x1}px`};
  vertical-align: top;
  ${media.mdUp`
    vertical-align: middle;
    padding: ${({ theme }) => `${theme.x0_5}px ${theme.x2}px`};
  `}
  &:first-child {
    border-radius: 8px 0 0 8px;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
    text-align: right;
  }
`;

type TypeRowCell = {
  color: string;
};
export const TypeRowCell = styled('td')<TypeRowCell>`
  background: ${({ color }) => color};
  border: ${({ theme }) => `${theme.x0_25}px solid ${theme.color.noir}`};
  border-left: 0;
  border-right: 0;

  ${RowCellStyle}
`;

export const TableRowCell = styled('td')`
  transition: background-color 0.4s ${cubicBezier};
  background-color: ${({ theme }) => theme.color.phantom};
  border: ${({ theme }) => `${theme.x0_25}px solid ${theme.color.noir}`};
  border-left: 0;
  border-right: 0;
  &:hover {
    background-color: ${({ theme }) => theme.color.phantomRGBA(0.7)};
  }
  &:first-child {
    border-radius: 8px 0 0 8px;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
  }
  ${RowCellStyle}
`;

export const CtaButton = styled(RouterLink)<Parameters<typeof Button>[0]>`
  ${buttonCSS}
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => `${theme.x0_5}px`};
  line-height: normal;
`;

export const ModalControlVariables = styled('div')`
  --chart-height: 310px;
  --table-header-height: 50px;
  --table-header-top: var(--chart-height);
  --template-columns: 1fr;
  --thead-top: calc(var(--chart-height) + var(--table-header-height));
  --modal-cross-btn-right: 8px;
  --modal-cross-btn-top: 10px;

  ${media.mdUp`
    --chart-height: 40vh;
    --table-header-height: 120px;
    --template-columns: 1fr 350px;
    --chart-height: 100dvh;
    --table-header-top: 0;
    --thead-top: var(--table-header-height);
    --modal-cross-btn-right: -10px;
    --modal-cross-btn-top: 10px;
  `}
  ${media.lgUp`
    --template-columns: 1fr 450px;
  `}
`;
